import { cn } from "@deputy-ai/common";
import { LoadingIcon } from "@deputy-ai/icons";

interface LoadingProps extends React.HTMLAttributes<HTMLElement> {
  iconClassName?: string;
}

export function Loading({ className, iconClassName }: LoadingProps) {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <LoadingIcon
        className={cn("h-12 w-12", iconClassName)}
        aria-hidden="true"
      />
    </div>
  );
}
